<template>
    <div class="range-input-custom">
      <vue-slider 
        :min="0" 
        :max="priceUp || 99999" 
        v-model="value"
        dotStyle="custom-dot-style"
        :tooltipStyle="'custom-style-dots'"
        ></vue-slider>
    </div>
</template>

<script>


export default {
    name: "range-input",
    components: {

    },
    props: {
        priceDown: {
            type: Number,
            required: false
        },
        priceUp: {
            type: Number,
            required: false
        },
        filterValue: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
             value: [0, 0],
        }
    },
    mounted() {
        this.value = this.filterValue
    },
    methods: {

    },
    watch: {
       priceUp(newValue, oldValue) {
         this.value = [this.priceDown, newValue]
         let val = oldValue
            val
       },
       value(newValue, oldValue) {
        this.$emit('setChangePrice', newValue)
        let val = oldValue
        val
       },
       filterValue(newValue, oldValue) {
         let val = oldValue
            val
        this.value = newValue
       }
    }
}
</script>

<style scoped>
    .range-input-custom {
        margin-top: 40px;
        padding: 0 16px;
    }
    .vue-slider-dot-tooltip-inner {
        background-color: #333;
        border-color: #333
    }
    .custom-dot-style {
        background-color: red;
    }
    .custom-style-dots {
         background-color: red;
    }
    .vue-slider-dot-tooltip-inner {
         background-color: red !important;
    }
</style>